<h1>{{ 'MENU.SEARCH_HEADER' | translate }}</h1>
<form id="header-search"
      (submit)="search($event)">
    <input type="search"
           (input)="search($event)"
           [placeholder]="'MENU.SEARCH_PLACEHOLDER' | translate"
           id="search-catalog-input"
           name="searchTerms">
    <button type="submit"
            [attr.aria-label]="'MENU.SEARCH_SUBMIT' | translate">
        <app-svg use="search"></app-svg>
    </button>
</form>
